<template>
    <div>
        <el-form :model="servcReqVoucher" ref="servcReqVoucherForm" class="demo-ruleForm">
            <div class="block-container">
                <div class="content-caption dashed bg-white">
                    <span>零售商信息</span>
                </div>
                <div class="form-single mt20 mb20">
                    <div class="title required">零售商</div>
                    <div class="content">
                        <div class="pos-rel" style="width: 225px">
                            <el-input class="width-1-5x bottom-line" :disabled="true" v-model="servcReqVoucher.buyerName"></el-input>
                            <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="selectRetailer"></i>
                        </div>
                    </div>
                </div>
                <div class="content-caption dashed bg-white">
                    <span>机构信息</span>
                </div>
                <div class="form-single mt20 mb20" style="overflow:visible">
                    <div class="title required">机构名称</div>
                    <div class="content">
                        <div class="pos-rel" style="width: 225px">
                            <el-form-item prop="buyerShopName">
                                <el-input class="width-1-5x bottom-line" :disabled="true" v-model="servcReqVoucher.buyerShopName"></el-input>
                                <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="selectRetailerShop"></i>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <div class="form-single mt20 mb20">
                    <div class="title">联系人</div>
                    <div class="content">
                        <div class="pos-rel" style="width: 225px">
                            <el-input class="width-1-5x bottom-line" :disabled="true" v-model="servcReqVoucher.contactName"></el-input>
                        </div>
                    </div>
                </div>
                <div class="content-caption dashed bg-white">
                    <span>地址信息</span>
                </div>
                <div class="form-single mt20 mb20">
                    <div class="title required">地址信息</div>
                    <div class="content">
                        <div class="pos-rel" style="width: 480px">
                            <swb-region :item="addressRegion" ref="swb_region"></swb-region>
                        </div>
                    </div>
                </div>
                <div class="form-single mt20 mb20">
                    <div class="title ">地址门牌号</div>
                    <div class="content">
                        <div class="pos-rel" style="width: 480px">
                            <el-input class="width-3x" v-model="servcReqVoucher.buyerShopStreet"></el-input>
                        </div>
                    </div>
                </div>
                <div class="form-single mt20 mb20">
                    <div class="title required">联系电话</div>
                    <div class="content">
                        <div class="pos-rel" style="width: 480px">
                            <el-input class="width-3x" v-model="servcReqVoucher.buyerShopContactTel"></el-input>
                        </div>
                    </div>
                </div>
                <div class="content-caption dashed bg-white">
                    <span>服务信息</span>
                </div>
                <div class="form-info">
                    <div class="form-row">
                        <div class="form-label">
                            <label class="required">紧急状态</label>
                        </div>
                        <div class="form-value">
                            <el-select placeholder="请选择" class="fl" v-model="servcReqVoucher.emgLevel" :clearable=true>
                                <el-option v-for="emgLevel in emgLevelList" :key="emgLevel.value" :label="emgLevel.text" :value="emgLevel.value"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-label">
                            <label>请求描述</label>
                        </div>
                        <div class="form-value">
                            <el-radio-group v-model="requestDescRedio" @change="addRequestDesc">
                                <el-radio label="情况紧急，需立即解决（默认）"></el-radio>
                                <el-radio label="按服务约定要求解决"></el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-label">
                            <label>&nbsp;</label>
                        </div>
                        <div class="form-value width-2x">
                            <el-input type="textarea" v-model="requestDesc"></el-input>
                        </div>
                    </div>
                </div>
                <div class="form-info">
                    <div class="form-row" style="height: 80px">
                        <div class="form-label">
                            <label>问题描述</label>
                        </div>
                        <div class="form-value width-2x">
                            <el-input type="textarea" v-model="troubleDesc"></el-input>
                        </div>
                    </div>
                </div>

                <div class="form-info">
                    <div class="form-row">
                        <div class="form-label">
                            <label>响应时长</label>
                        </div>
                        <div class="form-value width-2x">
                            <el-input class="width-1x" v-model="servcReqVoucher.yqRspTimeMi"></el-input>
                            <span>分钟</span>
                        </div>
                    </div>
                </div>
                <div class="form-info">
                    <div class="form-row">
                        <div class="form-label">
                            <label>要求到达时长</label>
                        </div>
                        <div class="form-value width-2x">
                            <el-input class="width-1x" v-model="servcReqVoucher.yqArriveTimeMi" @blur="arriveTimeChange(servcReqVoucher.yqArriveTimeMi)"></el-input>
                            <span>分钟</span>
                        </div>
                    </div>
                </div>
                <div class="form-info">
                    <div class="form-row">
                        <div class="form-label">
                            <label>要求完成时长</label>
                        </div>
                        <div class="form-value width-2x">
                            <el-input class="width-1x" v-model="servcReqVoucher.yqRepairedTimeMi"></el-input>
                            <span>分钟</span>
                        </div>
                    </div>
                </div>
                <div class="form-info">
                    <div class="form-row">
                        <div class="form-label">
                            <label>预约上门时间</label>
                        </div>
                        <div class="form-value width-1-5x">
                            <el-form-item prop="planTime">
                                <el-date-picker type="datetime" placeholder="请选择预约时间" v-model.date="servcReqVoucher.planTime" :picker-options="pickerOptions" format="yyyy-MM-dd HH:mm" style="width: 100%;"></el-date-picker>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <!-- 上传附件 -->
                <div class="content-caption dashed">
                    <span>附件信息</span>
                </div>
                <div class="form-single mt20">
                    <div class="content required" style="padding-left: 38px;">
                        <swb-file-upload fileGroup="image-goods" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone" :multipleFile="true"></swb-file-upload>
                        <div class="file-area clearfix">
                            <swb-file-item v-for="(servcReqVoucherFile, index) in servcReqVoucherFileList" :trackKey="index" :fileName="servcReqVoucherFile.name" :fileUuid="servcReqVoucherFile.fileUuid" :fileBrowseUrl="servcReqVoucherFile.fileBrowseUrl" :fileDownloadUrl="servcReqVoucherFile.fileDownloadUrl" :fileMd5="servcReqVoucherFile.fileMd5" :deletable="true" :onDelete="removeUpload"></swb-file-item>
                        </div>
                    </div>
                </div>

            </div>
        </el-form>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import servcDisptApi from '../../api/servcDispt'
    import { openMsuListByGoodsCatIdDlg } from '../servc/selectDlg'
    import { selectMerchantBizRelSelect } from '../merchant/showSelectDlg'
    import { openRetailComTreeSelectDlg, openRetailerSelectComnDlg } from '../retailer/selectDlg'

    import SwbRegion from '../comn/Region.vue'
    Vue.regist(SwbRegion);
    export default{
        name: 'swb-servc-req-voucher-save',
        desc: '保存/修改服务请求单',
        props: ['merchantId'],
        data: function () {
            return {
                servcReqVoucher: {
                    yqRspTimeMi: 30,
                    yqArriveTimeMi: 30,
                    yqRepairedTimeMi: 30,
                    emgLevel: '',
                    planTime: Date.now()
                },
                emgLevelList: getEnumList("emgLevel", 'value2text'),
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                addressRegion: {},
                requestDescRedio: "情况紧急，需立即解决（默认）",
                requestDesc: '情况紧急，需立即解决（默认）',

                troubleDesc: '',
                servcReqVoucherFileList: [],
            }
        },
        created: function () {
            if(!Utils.isNoB(this.servcReqVoucher.yqArriveTimeMi)) {
                let dateNow = new Date();
                this.servcReqVoucher.planTime = dateNow.setTime(dateNow.getTime() + this.servcReqVoucher.yqArriveTimeMi * 60 * 1000);
            }
        },
        methods: {
            // 要求到达时长变化事件
            arriveTimeChange: function (yqArriveTimeMi) {
                if(!Utils.isNoB(yqArriveTimeMi)) {
                    let dateNow = new Date();
                    this.servcReqVoucher.planTime = dateNow.setTime(dateNow.getTime() + yqArriveTimeMi * 60 * 1000);
                }
            },
            //上传前（进行验证检查）处理，可以返回false取消上传
            onBeforeUpload: function (fileItems, uploader) {
                if(fileItems.length === 0) {
                    this.$message.error('喂，你还没选择要上传的文件吧');
                    return false;
                }
            },
            //上传进度处理
            onProgress: function (progress) {
                let self = this;
                self.percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            //上传完毕处理（根据result.type判断是否有误）
            onUploadDone: function (result) {
                let self = this;
                if(result.type === 'info') {
                    let servcReqVoucherFileList = [];
                    let files = result.data.files;
                    for(let i = 0; i < files.length; i++) {
                        let file = files[i];
                        let servcReqVoucherFile = {};
                        servcReqVoucherFile.name = file.fileName;
                        servcReqVoucherFile.fileUuid = file.fileUuid;
                        servcReqVoucherFile.fileExtName = file.fileExtName;
                        servcReqVoucherFile.fileBrowseUrl = file.fileBrowseUrl;
                        servcReqVoucherFileList.push(servcReqVoucherFile);
                    }
                    let fileList = self.servcReqVoucherFileList.concat(servcReqVoucherFileList);
                    self.servcReqVoucherFileList = Utils.merge([], fileList);
                } else {
                    MsgBox.failure(result.message);
                }
            },
            removeUpload: function (index) {
                this.servcReqVoucherFileList.removeAt(index.trackKey);
                return false;
            },

            // 选择客户关系中的零售商
            selectRetailer: function () {
                let self = this;
                let servcReqVoucher = self.servcReqVoucher;
//                let dlgArgs = {};
//                dlgArgs.propMerchantType = getEnumInfoWith('merchantType', 'name', 'Retailer').value;
//                selectMerchantBizRelSelect(dlgArgs, function (result) {
//                    servcReqVoucher.buyerName = result.peerMerchantName;
//                    servcReqVoucher.buyerId = result.peerMerchantId;
//                    self.servcReqVoucher = Utils.merge({}, servcReqVoucher);
//                });
                let params = {
                    multiSelect: false,
                    initCheckedId: servcReqVoucher.buyerId,
                    showContract: true, // 合同
                    showOrder: true // 订单
                };
                openRetailerSelectComnDlg(params, function (result) {
                    let retail = result.checkedList || {};
                    servcReqVoucher.buyerId = retail.id;
                    servcReqVoucher.buyerName = retail.name;
                    servcReqVoucher.buyerShopId = null;
                    servcReqVoucher.buyerShopName = null;
                    servcReqVoucher.buyerShopUserName = null;
                    servcReqVoucher.contactTel = null;
                    servcReqVoucher.buyerShopStreet = null;
                    servcReqVoucher.buyerShopContactTel = null;
                    self.addressRegion = {};
                    self.servcReqVoucher = Utils.merge({}, servcReqVoucher);
                });
            },

            selectRetailerShop: function () {
                let self = this;
                let servcReqVoucher = this.servcReqVoucher;
                if(Utils.isNoB(servcReqVoucher.buyerId)) {
                    MsgBox.warning("请选择零售商");
                    return;
                }
                let dlgConfig = {};
                dlgConfig.comId = this.servcReqVoucher.buyerId;
                dlgConfig.isRadio = true;
                openRetailComTreeSelectDlg(dlgConfig, function (result) {
                    let shopRetail = result;
                    servcReqVoucher.buyerShopId = shopRetail.id;
                    servcReqVoucher.buyerShopName = shopRetail.name;
                    servcReqVoucher.buyerShopUserName = shopRetail.contactName;
                    servcReqVoucher.contactTel = shopRetail.contactTel;
                    servcReqVoucher.buyerShopStreet = shopRetail.street;
                    servcReqVoucher.buyerShopContactTel = shopRetail.contactTel;
                    let region = {};
                    region.cityId = shopRetail.cityId;
                    region.provinceId = shopRetail.provinceId;
                    region.countyId = shopRetail.countyId;
                    region.townId = shopRetail.townId;
                    self.addressRegion = region;
                    self.servcReqVoucher = Utils.merge({}, servcReqVoucher);
                });
            },

            addRequestDesc: function () {
                this.requestDesc = '';
                this.requestDesc = this.requestDescRedio;
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                let postData = self.servcReqVoucher;
                let resultData = this.$refs.swb_region.getDlgResult() || {};
                let regionInfo = resultData.data;
                if(resultData.type == "warn") {
                    result.type = resultData.type;
                    result.message = resultData.message;
                    return result;
                }
                if(Utils.isNoB(postData.buyerId)) {
                    result.type = "warn";
                    result.message = "请选择零售商";
                    return result;
                }
                if(Utils.isNoB(postData.buyerShopId)) {
                    result.type = "warn";
                    result.message = "请选择零售机构";
                    return result;
                }
                if(regionInfo.regionId == null) {
                    result.type = "warn";
                    result.message = "请选择地址或机构信息";
                    return result;
                }
                //
                if(!Utils.isPhoneNo(postData.buyerShopContactTel)) {
                    result.type = "warn";
                    result.message = "联系电话不正确";
                    return result;
                }
                //
                if(Utils.isNoB(postData.emgLevel)) {
                    result.type = "warn";
                    result.message = "请选择紧急状态";
                    return result;
                }
                //
                if(!Utils.isNoB(self.troubleDesc)) {
                    if(self.troubleDesc.length < 15) {
                        result.type = "warn";
                        result.message = "问题描述不能少于15个字";
                        return result;
                    }
                }
                //
                postData.requestDesc = self.requestDesc;
                postData.troubleDesc = self.troubleDesc;
                postData.buyerShopProvinceId = regionInfo.provinceId;
                postData.buyerShopCityId = regionInfo.cityId;
                postData.buyerShopCountyId = regionInfo.countyId;
                postData.buyerShopRegionId = regionInfo.regionId;
                postData.servicerStoreFlag = false;
                postData.svcDispatched = false;
                postData.servcReqVoucherFileList = self.servcReqVoucherFileList;
                result.type = 'info';
                result.data = postData;
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/servcReq/ServcReqVoucherSave.vue